'use strict';

var $Object = require('./');
var RequireObjectCoercible = require('./RequireObjectCoercible');

/** @type {import('./ToObject')} */
module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-object-atoms/ToObject.js
// module id = 1274
// module chunks = 4